import React from "react";

export default function StackedList(props) {
    return (
        <div className="overflow-hidden bg-white shadow sm:rounded-md">
            <ul className="divide-y divide-gray-200">{props.children}</ul>
        </div>
    );
}

export function StackedListItem(props) {
    return <li>{props.children}</li>;
}
